import { SectionTag } from "../../../../data/models/documentProperties/section";
import { RootState } from "../../../reducers";

export const sectionTagsSelector = (state: RootState): SectionTag[] =>
  state.currentDocument.document.sectionTags;
